import { useContext } from 'react'

import { GroupDataUpdateContext } from '../providers/GroupDataProvider'

export default function useGroupDataUpdate() {
  return useContext(GroupDataUpdateContext)
}
